import React from 'react'
import PropTypes from 'prop-types'
import { SelectBankAccountCard } from '../../molecules/SelectBankAccountCard'
import { Text } from '../../atoms/text'
import { useTranslation } from '../../../context/translationProvider'
import { StyledBankListWrapper, StyledTextWrapper } from './styles'
import { Link } from 'gatsby'

export const WithdrawBankAccountList = ({
  selectedBank,
  setSelectedBank,
  bankAccounts = [],
}) => {
  const { translate } = useTranslation()

  const onSelectBank = (bank) => {
    setSelectedBank(bank)
  }

  return (
    <div>
      <StyledTextWrapper>
        <Text bold style={{ fontSize: 22 }} noMargin>
          {translate('payments.withdraw.bankAccount.title')}
        </Text>
        <Text theme="light" style={{ fontSize: 14 }}>
          {translate('payments.withdraw.bankAccount.description')}
        </Text>
      </StyledTextWrapper>
      <StyledBankListWrapper>
        {bankAccounts.map((bankAccount, index) => (
          <SelectBankAccountCard
            key={index}
            bankAccount={bankAccount}
            onClick={onSelectBank}
            isChecked={selectedBank?.id === bankAccount.id}
          />
        ))}
      </StyledBankListWrapper>
      <Text style={{ marginBottom: '40px' }}>
        <Link to="/account/bank-accounts/" style={{ color: '#000' }}>
          Manage My Accounts
        </Link>
      </Text>
    </div>
  )
}

WithdrawBankAccountList.propTypes = {
  selectedBank: PropTypes.object,
  setSelectedBank: PropTypes.func,
  bankAccounts: PropTypes.array,
}
